import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'components/UIElements'
import '../styles/d3/onboardingPrompt.scss'
import { closeIcon, humiS, isabellaS } from '../assets/assets'

const OnboardingPrompt = ({
  type,
  closeFunc,
  strings,
  humiIsabellaDisabled
}) => {
  const isActivities = type === 'activities'
  return (
    <div className={`onboarding${isActivities ? '' : ' announcements'}`}>
      <Button className='close' onClick={() => closeFunc()}>
        {closeIcon()}
      </Button>
      <div className='flexed'>
        {!humiIsabellaDisabled ? (
          <div className='onboarding-avatar'>
            <img
              className={!isActivities ? 'isabella-onboarding' : ''}
              src={isActivities ? humiS : isabellaS}
              alt='activities-onboarding-humi'
            />
          </div>
        ) : null}
        <div>
          <p>{strings[isActivities ? 'hi_intro' : 'inbox_hello']}</p>
          <p>
            {
              strings[
                isActivities ? 'activities_state' : 'activities_pass_along'
              ]
            }
          </p>
        </div>
      </div>
    </div>
  )
}

OnboardingPrompt.propTypes = {
  closeFunc: PropTypes.func,
  type: PropTypes.string,
  strings: PropTypes.objectOf(PropTypes.string)
}

export default OnboardingPrompt
